import { useContext, useMemo } from 'react';
import get from 'lodash/get';

import { convertFieldIdToObjectPath } from '@/components/organisms/DynamicForm/hooks/useWarnings/utils/convertFieldIdToObjectPath';
import { warningsContext } from '@/components/organisms/DynamicForm/warnings.context';

export const useWarnings = (fieldId: string) => {
  const { warnings } = useContext(warningsContext);

  const fieldWarnings = useMemo(
    () => get(warnings, convertFieldIdToObjectPath(fieldId), null),
    [fieldId, warnings],
  );

  return {
    fieldWarnings,
  };
};
